document.querySelectorAll('.promotion-slider').forEach((slider) => {
	const slides = slider.querySelectorAll('.swiper-slide');
	const loopEnabled = slides.length > 1;

	new window.Swiper(slider, {
		slidesPerView: 1,
		spaceBetween: 16,
		loop: loopEnabled,
		navigation: {
			nextEl: '.promotion-slider__btn--next',
			prevEl: '.promotion-slider__btn--prev',
			disabledClass: 'promotion-slider__btn--disabled',
		},
	});
});
